/* Theme scripts. No dependencies. */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* Visitor asked for less motion: system setting or the accessibility bar's "stop animations". */
  var motionOff = function () {
    return document.documentElement.classList.contains('a11y-stop') ||
           window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };
  var onMotionChange = function (fn) {
    new MutationObserver(fn).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  };

  /* ---------------- Sticky header shadow ---------------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------- Announcement bar ----------------
     Desktop has room for every message, so they sit side by side and nothing moves.
     On phones they rotate, with a pause button, a pause on hover/focus, and no
     rotation at all when the visitor asked for less motion. */
  var rotator = $('[data-announce]');
  if (rotator) {
    var messages = $$('[data-announce-item]', rotator);
    if (messages.length > 1) {
      var current = 0;
      var interval = parseInt(rotator.getAttribute('data-interval'), 10) || 3000;
      var timer = null;
      var userPaused = false;
      var toggle = $('[data-announce-toggle]', rotator.parentNode);
      var narrow = window.matchMedia('(max-width: 899px)');

      var show = function (next) {
        messages[current].classList.remove('is-active');
        messages[current].setAttribute('aria-hidden', 'true');
        current = next;
        messages[current].classList.add('is-active');
        messages[current].removeAttribute('aria-hidden');
      };
      var stop = function () {
        clearInterval(timer);
        timer = null;
      };
      var start = function () {
        if (timer || userPaused || motionOff() || !narrow.matches || document.hidden) return;
        timer = setInterval(function () {
          show((current + 1) % messages.length);
        }, interval);
      };
      var applyLayout = function () {
        if (narrow.matches) {
          messages.forEach(function (m, i) {
            if (i === current) m.removeAttribute('aria-hidden'); else m.setAttribute('aria-hidden', 'true');
          });
          start();
        } else {
          stop();
          messages.forEach(function (m) { m.removeAttribute('aria-hidden'); });
        }
      };

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });
      rotator.addEventListener('mouseenter', stop);
      rotator.addEventListener('mouseleave', start);
      rotator.addEventListener('focusin', stop);
      rotator.addEventListener('focusout', start);
      if (toggle) {
        toggle.addEventListener('click', function () {
          userPaused = !userPaused;
          toggle.setAttribute('aria-pressed', String(userPaused));
          toggle.setAttribute('aria-label', userPaused ? 'متابعة تبديل الرسائل' : 'إيقاف تبديل الرسائل');
          if (userPaused) stop(); else start();
        });
      }
      onMotionChange(function () { if (motionOff()) stop(); else start(); });
      if (narrow.addEventListener) narrow.addEventListener('change', applyLayout);
      applyLayout();
    }
  }

  /* ---------------- Mobile drawer ---------------- */
  var drawer = $('[data-drawer]');
  if (drawer) {
    var lastFocus = null;

    var openDrawer = function () {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var first = $('a, button', drawer);
      if (first) first.focus();
    };

    var closeDrawer = function () {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    };

    $$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', openDrawer); });
    $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !drawer.classList.contains('is-open')) return;
      closeDrawer();
    });

    // Focus trap
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var items = $$('a[href], button:not([disabled])', drawer).filter(function (el) {
        return el.offsetParent !== null;
      });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------------- Product gallery ---------------- */
  var gallery = $('[data-gallery]');
  if (gallery) {
    var main = $('[data-gallery-main]', gallery);
    $$('[data-gallery-thumb]', gallery).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        var alt = thumb.getAttribute('data-alt') || '';
        var img = $('img', main);
        var videoFrame = $('[data-gallery-video]', main);
        var imageFrame = $('[data-gallery-image]', main);
        gallery.classList.toggle('gallery--square', thumb.hasAttribute('data-carousel-square'));
        if (videoFrame && imageFrame) {
          var showVideo = thumb.hasAttribute('data-show-video');
          videoFrame.hidden = !showVideo;
          imageFrame.hidden = showVideo;
          var video = $('video', videoFrame);
          if (!showVideo) video.pause();
          else if (!video._userPaused && !motionOff()) {
            var playback = video.play();
            if (playback && playback.catch) playback.catch(function () {});
          }
        }
        if (src && img) { img.src = src; img.alt = alt; img.removeAttribute('srcset'); }
        $$('[data-gallery-thumb]', gallery).forEach(function (t) {
          t.setAttribute('aria-current', String(t === thumb));
        });
      });
    });
  }

  /* Manual gallery carousel: video remains the initial slide. */
  if (gallery) {
    var galleryThumbs = $$('[data-gallery-thumb]', gallery);
    function galleryStep(delta) {
      var active = galleryThumbs.findIndex(function (t) { return t.getAttribute('aria-current') === 'true'; });
      var next = galleryThumbs[(Math.max(0, active) + delta + galleryThumbs.length) % galleryThumbs.length];
      if (next) { next.click(); next.scrollIntoView({block:'nearest', inline:'nearest'}); }
    }
    $('[data-gallery-prev]', gallery).addEventListener('click', function () { galleryStep(-1); });
    $('[data-gallery-next]', gallery).addEventListener('click', function () { galleryStep(1); });
    var touchStart = null;
    main.addEventListener('touchstart', function (e) {
      touchStart = e.touches.length === 1 ? {x:e.touches[0].clientX, y:e.touches[0].clientY} : null;
    }, {passive:true});
    main.addEventListener('touchend', function (e) {
      if (!touchStart || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - touchStart.x;
      var dy = e.changedTouches[0].clientY - touchStart.y;
      touchStart = null;
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) galleryStep(dx > 0 ? 1 : -1);
    }, {passive:true});
    main.addEventListener('touchcancel', function () { touchStart = null; }, {passive:true});
  }

  /* ---------------- Quantity steppers ---------------- */
  $$('[data-qty]').forEach(function (box) {
    var input = $('input', box);
    if (!input) return;
    $$('[data-qty-step]', box).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-qty-step'), 10);
        var min = parseInt(input.getAttribute('min') || '1', 10);
        var next = (parseInt(input.value, 10) || min) + step;
        input.value = String(Math.max(min, next));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------------- Sticky buy bar ---------------- */
  var buybar = $('[data-buybar]');
  var atc = $('[data-atc-anchor]');
  if (buybar && atc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // 5.10: shown from the first screen on mobile, so price + buy button are always in view;
        // hidden only while the main button itself is on screen.
        buybar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 }).observe(atc);
  }

  /* ---------------- Reveal on scroll ---------------- */
  var reveals = $$('.reveal');
  if (reveals.length) {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var ro = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          obs.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { ro.observe(el); });
    }
  }

  /* ---------------- Background videos ----------------
     Play only while on screen; stay paused when the visitor asked for less motion
     (system setting or the "stop animations" button in the accessibility bar). */
  var videos = $$('[data-video] video');
  if (videos.length) {
    var sync = function (v) {
      if (v._inView && !v._userPaused && !motionOff()) {
        v.muted = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () { /* autoplay blocked: poster stays */ });
      } else {
        v.pause();
      }
    };
    if ('IntersectionObserver' in window) {
      var vo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target._inView = entry.isIntersecting;
          sync(entry.target);
        });
      }, { rootMargin: '150px 0px' });
      videos.forEach(function (v) { vo.observe(v); });
    } else {
      videos.forEach(function (v) { v._inView = true; sync(v); });
    }
    onMotionChange(function () { videos.forEach(sync); });

    // A visible pause/play button on every video (WCAG 2.2.2).
    videos.forEach(function (v) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'media__pause';
      btn.setAttribute('aria-label', 'إيقاف الفيديو');
      btn.innerHTML =
        '<svg class="icon-pause" width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1" fill="currentColor"/><rect x="14" y="5" width="4" height="14" rx="1" fill="currentColor"/></svg>' +
        '<svg class="icon-play" width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>';
      btn.addEventListener('click', function () {
        v._userPaused = !v._userPaused;
        btn.classList.toggle('is-paused', v._userPaused);
        btn.setAttribute('aria-label', v._userPaused ? 'تشغيل الفيديو' : 'إيقاف الفيديو');
        sync(v);
      });
      v.parentNode.appendChild(btn);
    });
  }

  /* ---------------- Accordion: one open at a time ---------------- */
  $$('[data-accordion]').forEach(function (group) {
    var items = $$('details', group);
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) { if (other !== item) other.open = false; });
      });
    });
  });

  /* ---------------- Cart line item quantity ---------------- */
  $$('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });

  /* ---------------- Bundle pricing ----------------
     A product sold in packs (option "pack") always checks out as the cheapest mix of
     packs: 3 singles become one triple, 5 units a triple and a pair. Every quantity change
     reloads the cart page, and the page re-balances itself on load, so checkout always
     receives the balanced cart. */
  var ils = function (cents) { return '€' + (cents / 100).toLocaleString('en', { maximumFractionDigits: 2 }); };

  // Cheapest way to make exactly n units out of packs [{id, units, price}].
  var bestMix = function (n, packs) {
    var cost = [0], pick = [null];
    for (var i = 1; i <= n; i++) {
      cost[i] = Infinity;
      packs.forEach(function (p) {
        if (p.units <= i && cost[i - p.units] + p.price < cost[i]) { cost[i] = cost[i - p.units] + p.price; pick[i] = p; }
      });
    }
    var mix = {};
    packs.forEach(function (p) { mix[p.id] = 0; });
    for (var k = n; k > 0 && pick[k]; k -= pick[k].units) mix[pick[k].id]++;
    return { mix: mix, cost: cost[n] };
  };

  var bundleCart = $('[data-bundle-cart]');
  if (bundleCart) {
    var bc = null;
    try { bc = JSON.parse(bundleCart.textContent); } catch (e) { /* leave the cart as is */ }
    if (bc) {
      var updates = {}, rebalance = false, saving = 0;
      Object.keys(bc.packs).forEach(function (pid) {
        var packs = bc.packs[pid], units = 0, have = {};
        bc.items.forEach(function (it) {
          var p = packs.find(function (x) { return x.id === it.variant; });
          if (!p) return;
          units += p.units * it.qty;
          have[p.id] = (have[p.id] || 0) + it.qty;
        });
        if (!units) return;
        var best = bestMix(units, packs);
        packs.forEach(function (p) {
          if ((have[p.id] || 0) !== best.mix[p.id]) rebalance = true;
          updates[p.id] = best.mix[p.id];
        });
        var single = packs.find(function (p) { return p.units === 1; });
        if (single) saving += single.price * units - best.cost;
      });
      var cartForm = bundleCart.closest('form');
      if (rebalance) {
        if (cartForm) cartForm.classList.add('is-bundling');
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) {
          if (!r.ok) throw new Error(r.status);
          window.location.reload();
        }).catch(function () {
          if (cartForm) cartForm.classList.remove('is-bundling');
        });
      } else if (saving > 0) {
        var note = $('[data-bundle-note]');
        if (note) {
          note.innerHTML = '✓ تم احتساب السعر تلقائياً حسب العرض الأوفر. وفّرت <strong>' + ils(saving) + '</strong> مقارنة بالشراء بالقطعة.';
          note.hidden = false;
        }
      }
    }
  }

  // Product page: tell the buyer what the cart will turn their quantity into.
  var bundleHint = $('[data-bundle-hint]');
  var productForm = $('#product-form');
  var variantData = $('[data-variant-data]');
  if (bundleHint && productForm && variantData) {
    var vlist = [];
    try { vlist = JSON.parse(variantData.textContent); } catch (e) { /* no hint */ }
    var radios = $$('input[data-units]', productForm);
    var ppacks = radios.map(function (r) {
      var v = vlist.find(function (x) { return x.options.indexOf(r.value) !== -1; });
      return v ? { id: v.id, units: parseInt(r.getAttribute('data-units'), 10) || 1, price: v.price, name: r.value } : null;
    }).filter(Boolean);
    var qtyField = $('input[name="quantity"]', productForm);
    var showHint = function () {
      var r = radios.find(function (x) { return x.checked; });
      var pack = r && ppacks.find(function (p) { return p.name === r.value; });
      var q = qtyField ? parseInt(qtyField.value, 10) || 1 : 1;
      if (!pack || q < 2) { bundleHint.hidden = true; return; }
      var best = bestMix(pack.units * q, ppacks), plain = pack.price * q;
      if (best.cost >= plain) { bundleHint.hidden = true; return; }
      var parts = ppacks.slice().sort(function (a, b) { return b.units - a.units; })
        .filter(function (p) { return best.mix[p.id]; })
        .map(function (p) { return (best.mix[p.id] > 1 ? best.mix[p.id] + ' × ' : '') + p.name; });
      bundleHint.innerHTML = '✓ في السلة سيُحتسب تلقائياً كـ ' + parts.join(' + ') + ': <strong>' + ils(best.cost) + '</strong> بدلاً من ' + ils(plain) + '.';
      bundleHint.hidden = false;
    };
    productForm.addEventListener('change', showHint);
    productForm.addEventListener('input', showHint);
    showHint();
  }

  /* ---------------- Cart: terms must be accepted before checkout ----------------
     The checkbox is `required`, so the browser blocks the checkout button even without
     this script. Here we swap the browser bubble for an inline Hebrew message and
     stamp the approval with the date and time, which is saved on the order. */
  var termsBox = $('[data-terms-box]');
  if (termsBox) {
    var termsWrap = termsBox.closest('[data-terms]');
    var termsError = $('[data-terms-error]', termsWrap);
    var TERMS_MSG = 'للمتابعة إلى الدفع يرجى تأكيد الموافقة على الشروط والأحكام.';
    var syncTerms = function () {
      termsBox.setCustomValidity(termsBox.checked ? '' : TERMS_MSG);
      termsBox.value = termsBox.checked ? 'yes · ' + new Date().toISOString() : 'yes';
      if (termsBox.checked) {
        termsWrap.classList.remove('is-error');
        if (termsError) termsError.hidden = true;
      }
    };
    syncTerms();
    termsBox.addEventListener('change', syncTerms);
    termsBox.addEventListener('invalid', function (e) {
      e.preventDefault();
      termsWrap.classList.add('is-error');
      if (termsError) termsError.hidden = false;
      termsWrap.scrollIntoView({ block: 'center', behavior: 'smooth' });
      termsBox.focus({ preventScroll: true });
    });
  }

  /* ---------------- Cookie notice ----------------
     An informational notice, shown until the visitor closes it. Tracking doesn't
     wait for it where consent is not required by law. Closing
     it records consent in Shopify's Customer Privacy API, which matters only for
     visitors from regions that require consent. */
  var cookieBanner = $('[data-cookie-banner]');
  if (cookieBanner) {
    var COOKIE_KEY = 'am-cookies';
    var rootEl = document.documentElement;
    var readChoice = function () {
      try { return localStorage.getItem(COOKIE_KEY); } catch (e) { return null; }
    };
    var saveChoice = function (v) {
      try { localStorage.setItem(COOKIE_KEY, v); } catch (e) { /* private mode */ }
    };
    var showCookies = function () {
      cookieBanner.hidden = false;
      rootEl.classList.add('has-cookie-banner');
      rootEl.style.setProperty('--cookie-h', cookieBanner.offsetHeight + 'px');
    };
    var hideCookies = function () {
      cookieBanner.hidden = true;
      rootEl.classList.remove('has-cookie-banner');
    };
    var withPrivacyApi = function (done) {
      var S = window.Shopify;
      if (S && S.customerPrivacy) return done(S.customerPrivacy);
      if (S && S.loadFeatures) {
        S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          done(err ? null : window.Shopify.customerPrivacy);
        });
      } else {
        done(null);
      }
    };

    withPrivacyApi(function (privacy) {
      var choice = readChoice();
      if (!choice && privacy && privacy.currentVisitorConsent) {
        var c = privacy.currentVisitorConsent() || {};
        if (c.analytics === 'yes') choice = 'yes';
      }
      if (choice !== 'yes') showCookies();

      cookieBanner.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cookie]');
        if (!btn) return;
        var yes = btn.getAttribute('data-cookie') === 'accept';
        saveChoice(yes ? 'yes' : 'no');
        hideCookies();
        if (privacy && privacy.setTrackingConsent) {
          privacy.setTrackingConsent({ analytics: yes, marketing: yes, preferences: yes }, function () {});
        }
      });
    });

    window.addEventListener('resize', function () {
      if (!cookieBanner.hidden) rootEl.style.setProperty('--cookie-h', cookieBanner.offsetHeight + 'px');
    });
  }

  /* ---------------- Accessibility toolbar ---------------- */
  var a11yToggle = $('[data-a11y-toggle]');
  var a11yPanel = $('[data-a11y-panel]');

  if (a11yToggle && a11yPanel) {
    var MODES = ['contrast', 'light', 'gray', 'links', 'headings', 'readable', 'spacing', 'cursor', 'focus', 'stop'];
    var EXCLUSIVE = { contrast: 'light', light: 'contrast' };
    var STORE = 'am-a11y';
    var root = document.documentElement;

    var readState = function () {
      try { return JSON.parse(localStorage.getItem(STORE) || '{}'); }
      catch (e) { return {}; }
    };
    var writeState = function (state) {
      try { localStorage.setItem(STORE, JSON.stringify(state)); } catch (e) { /* private mode */ }
    };

    var apply = function (state) {
      MODES.forEach(function (m) { root.classList.toggle('a11y-' + m, !!state[m]); });
      root.style.fontSize = state.zoom ? state.zoom + '%' : '';
      $$('[data-a11y-mode]').forEach(function (btn) {
        btn.setAttribute('aria-pressed', String(!!state[btn.getAttribute('data-a11y-mode')]));
      });
      var zoomOut = $('[data-a11y-zoom-label]');
      if (zoomOut) zoomOut.textContent = (state.zoom || 100) + '%';
    };

    var state = readState();
    apply(state);

    a11yToggle.addEventListener('click', function () {
      var open = a11yPanel.hasAttribute('hidden');
      if (open) a11yPanel.removeAttribute('hidden'); else a11yPanel.setAttribute('hidden', '');
      a11yToggle.setAttribute('aria-expanded', String(open));
      if (open) { var f = $('button', a11yPanel); if (f) f.focus(); }
    });

    $$('[data-a11y-mode]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mode = btn.getAttribute('data-a11y-mode');
        state[mode] = !state[mode];
        if (state[mode] && EXCLUSIVE[mode]) state[EXCLUSIVE[mode]] = false;
        writeState(state); apply(state);
      });
    });

    $$('[data-a11y-zoom]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.getAttribute('data-a11y-zoom'), 10);
        var current = state.zoom || 100;
        state.zoom = Math.min(140, Math.max(100, current + dir * 10));
        writeState(state); apply(state);
      });
    });

    var reset = $('[data-a11y-reset]');
    if (reset) {
      reset.addEventListener('click', function () {
        state = {};
        writeState(state); apply(state);
      });
    }

    document.addEventListener('click', function (e) {
      if (a11yPanel.hasAttribute('hidden')) return;
      if (a11yPanel.contains(e.target) || a11yToggle.contains(e.target)) return;
      a11yPanel.setAttribute('hidden', '');
      a11yToggle.setAttribute('aria-expanded', 'false');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || a11yPanel.hasAttribute('hidden')) return;
      a11yPanel.setAttribute('hidden', '');
      a11yToggle.setAttribute('aria-expanded', 'false');
      a11yToggle.focus();
    });
  }
})();

/* Rotate existing customer reviews; honor reduced motion and manual pause. */
document.querySelectorAll('[data-product-proof]').forEach(function(root) {
  var slides=Array.from(root.querySelectorAll('[data-proof-slide]')), index=0, paused=false;
  var pause=root.querySelector('[data-proof-pause]'), next=root.querySelector('[data-proof-next]');
  var motion=window.matchMedia('(prefers-reduced-motion: reduce)');
  if(slides.length<2){pause.hidden=true;next.hidden=true;return;}
  function advance(){slides[index].hidden=true;index=(index+1)%slides.length;slides[index].hidden=false;}
  next.addEventListener('click',advance);
  pause.addEventListener('click',function(){paused=!paused;pause.setAttribute('aria-pressed',String(paused));pause.setAttribute('aria-label',paused?'تشغيل تبديل المراجعات':'إيقاف تبديل المراجعات');pause.textContent=paused?'▶':'Ⅱ';});
  window.setInterval(function(){if(!paused&&!motion.matches&&!document.hidden&&!root.matches(':hover')&&!root.contains(document.activeElement))advance();},6000);
});



document.querySelectorAll('[data-proof-marquee]').forEach(function(root) {
  var pause=root.querySelector('[data-marquee-pause]');
  pause.addEventListener('click',function(){
    var paused=root.classList.toggle('is-paused');
    pause.setAttribute('aria-pressed',String(paused));
    pause.setAttribute('aria-label',paused?'تشغيل حركة المراجعات':'إيقاف حركة المراجعات');
    pause.textContent=paused?'▶':'Ⅱ';
  });
});

